import React, { Component } from 'react';

class DisabledMonthlyCommitment extends Component {
  render() {
    const { monthlyPlan } = this.props;
    return (
      <div className="col px-0">
        <div className="activate-content__schedule-wrapper activate-content__disabled-commitment-level ">
          <div className="activate-content__commitment-period">
            <div className="activate-content__display-only-flex">
              <div>
                <p className="activate-content__shared-period-title">Month</p>
              </div>
            </div>
          </div>
          <div className="activate-content__schedule-hours align-items-end">
            <div className="period-select__title">
              <p className="activate-content__commitment-cost">{'$' + monthlyPlan.price.month }</p>
              <small>&nbsp;/mo</small>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DisabledMonthlyCommitment;



// WEBPACK FOOTER //
// ./src/components/PlanSelect/DisabledMonthlyCommitment/index.js